var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RouterLink',{staticClass:"rules",attrs:{"to":"/rules"}},[_vm._v("Rules")])}
var staticRenderFns = []

export { render, staticRenderFns }